import { Payment } from '@linktivity/link-payment';
import { message } from '@linktivity/link-ui';
import i18n from '@/i18n';
import { BASE_PATH } from '@/constants/env';

const config = new Payment.Configuration({
  basePath: BASE_PATH,
  middleware: [
    {
      post: async context => {
        if (context.response.status === 404) {
          location.href = '/404';
        } else if (!context.response.ok) {
          // handle error
          const data = await context.response.json();
          const errorCode = data?.common?.error_code;
          const errorKey = `payError.${errorCode}`;
          message.error(
            i18n.exists(errorKey)
              ? i18n.t(errorKey)
              : data?.common?.error_description || errorCode,
            10
          );
        }
      }
    }
  ]
});

export default config;
